import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
const BUILD_VERSION = 'v13.1-' + Date.now();

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { BUILD_VERSION };
export default api;

// Helper functions — locale-aware. Number locale follows the UI language; the business
// currency is USD for both Hebrew and English users (Marshall settles in USD).
const _locale = () => (localStorage.getItem('lang') === 'he' ? 'he-IL' : 'en-US');

export const fmt = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '--';
  return new Intl.NumberFormat(_locale(), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(n);
};

export const fmtNum = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '--';
  return new Intl.NumberFormat(_locale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
};

// Format quantities — no trailing .00 (300 not 300.00, but 2.5 stays 2.5)
export const fmtQty = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '--';
  return new Intl.NumberFormat(_locale(), { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n);
};

export const fmtInt = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '--';
  return new Intl.NumberFormat(_locale(), { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
};

export const fmtDate = (d) => {
  if (!d) return '--';
  // he users get DD/MM/YYYY, en users get DD MMM YYYY — same data, locale-appropriate.
  return new Date(d).toLocaleDateString(localStorage.getItem('lang') === 'he' ? 'he-IL' : 'en-GB',
    localStorage.getItem('lang') === 'he'
      ? { day: '2-digit', month: '2-digit', year: 'numeric' }
      : { day: '2-digit', month: 'short', year: 'numeric' }
  );
};

export const daysUntil = (date) => {
  if (!date) return null;
  const now = new Date();
  const due = new Date(date);
  return Math.ceil((due - now) / (1000 * 60 * 60 * 24));
};
